// src/App.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // Pour suivre les pages
import AppRouter from './router';
import Header from './components/Header/Header';
import ImageBanner from './components/ImageBanner/ImageBanner';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import './App.css';
import './assets/styles/global.css';
import CookieConsentBanner from './components/coockie/CookieConsentBanner';

function App() {
  const location = useLocation();

  // Charger le script Google Analytics une seule fois
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-T9HP0PJVHC';
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', 'G-T9HP0PJVHC');
  }, []);

  // Suivre les changements de page (SPA)
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-T9HP0PJVHC', {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <ImageBanner />
      <Navbar />
      <main className="container">
        <AppRouter />
      </main>
      <CookieConsentBanner />
      <Footer />
    </div>
  );
}

export default App;
